const BOOKING_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ15eVy1VA1KvKmjdJqpewq3sc4TOL5FqtoHGz9yGiFfMojsOFFet9Q0lpqwtzBA1AdOxNAeUTIP?gv=true";

export const BookingEmbed = ({ title = "Book your onboarding call", subtitle }) => {
  return (
    <div data-testid="booking-embed">
      {title && <h2 className="text-2xl lg:text-3xl tracking-tight font-medium text-ink">{title}</h2>}
      {subtitle && <p className="mt-3 text-dark-gray leading-relaxed max-w-xl">{subtitle}</p>}
      <div className="mt-6 border border-silver/50 bg-white overflow-hidden">
        <iframe
          src={BOOKING_URL}
          title="Book an appointment with Systems Beyond"
          className="w-full"
          style={{ border: 0, height: 640 }}
          frameBorder="0"
        />
      </div>
    </div>
  );
};
